'use strict';

module.exports = trimLines;

var ws = /[ \t]*\n+[ \t]*/g;
var newline = '\n';

function trimLines(value) {
  return String(value).replace(ws, newline);
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/trim-lines/index.js
// module id = 979
// module chunks = 0